<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>CẬP NHẬT PHÒNG KIỂM TRA</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 py-0">
        <v-form v-bind="this.$attrs" ref="form">
          <div>
            <div class="pt-6">
              <div class="d-flex">
                <div class="d-flex" style="flex-grow: 1">
                  <v-text-field
                    :label="`Tên phòng kiểm tra`"
                    v-model="room.name"
                    outlined
                    style="flex-grow: 1"
                    class="pr-6 required"
                    required
                    :rules="[$rules.required]"
                  ></v-text-field>
                  <v-text-field
                    label="Mã phòng"
                    v-model="room.code"
                    outlined
                    style="flex-grow: 1"
                    class="pr-6 required"
                    required
                    :rules="[$rules.required]"
                  ></v-text-field>
                  <v-text-field
                    label="Buổi"
                    v-model="room.note"
                    outlined
                    style="flex-grow: 1"
                    class="pr-6 required"
                    required
                    :rules="[$rules.required]"
                  ></v-text-field>
                  <v-text-field
                    label="Số lượng"
                    v-model="room.capacity"
                    outlined
                    style="flex-grow: 1"
                    class="required"
                    required
                    :rules="[$rules.number]"
                  ></v-text-field>
                </div>
              </div>
              <div>
                <v-text-field
                  label="Địa điểm"
                  v-model="room.location"
                  outlined
                  class="required"
                  required
                  :rules="[$rules.required]"
                ></v-text-field>
              </div>
              <div class="d-flex flex-wrap">
                <div
                  v-for="(subjectGroup, groupIndex) in groupedSubjects"
                  :key="groupIndex"
                  class="d-flex"
                  style="width: 100%"
                >
                  <div class="d-flex" style="width: 100%">
                    <v-checkbox
                      v-for="(subject, subjectIndex) in subjectGroup"
                      :key="subjectIndex"
                      v-model="selectedSubjects"
                      :value="subject.id"
                      :label="subject.name"
                      class="pt-0 mt-0 pb-6"
                      hide-details
                      style="flex-basis: 33%"
                    ></v-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-form>
      </v-card-text>

      <v-divider> </v-divider>
      <v-card-actions class="pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { chunk } from 'lodash'
export default {
  props: {
    state: Boolean,
    subjects: Array,
    data: Object
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    },
    data: {
      immediate: true,
      handler(newData) {
        if (newData) {
          this.setFormValues(newData)
        }
      }
    }
  },
  computed: {
    groupedSubjects() {
      return chunk(this.subjects, 3)
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      selectedSubjects: [],
      room: {
        name: '',
        code: '',
        location: '',
        note: '',
        capacity: 0,
        subjects: [],
        exam: this.$route.params.id
      }
    }
  },
  methods: {
    ...mapActions('room', ['updateRoom']),
    close() {
      this.$emit('closeDialog')
      this.$refs.form.resetValidation()
    },

    isSubjectSelected(room, subject) {
      return room.subjects.some(s => s.id === subject.id)
    },
    handleCheckboxChange(room, subject) {
      const index = room.subjects.findIndex(s => s.id === subject.id)
      if (index >= 0) {
        room.subjects.splice(index, 1)
      } else {
        room.subjects.push(subject)
      }
    },

    resetForm() {
      this.room = {
        name: '',
        code: '',
        location: '',
        note: '',
        capacity: 0,
        subjects: this.selectedSubjects.map(id => ({ id })),
        exam: this.$route.params.id
      }
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        const roomData = this.room
        roomData.subjects = this.selectedSubjects
        const updatedRoom = await this.updateRoom({ id: this.data.id, ...roomData })
        if (updatedRoom) {
          this.$emit('refresh')
          this.resetForm()
          this.close()
        }
        this.$loading.active = false
      }
    },

    setFormValues(data) {
      this.room.name = data.name || ''
      this.room.code = data.code || ''
      this.room.location = data.location || ''
      this.room.capacity = data.capacity || 0
      this.room.note = data.note || ''
      this.room.subjects = data.subjects || []
      this.selectedSubjects = data.subjects.map(s => s.id)
    }
  }
}
</script>
